class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this)),
    );
  }

  open() {
    this.notification.classList.add("animate", "active");

    // オーバーレイを表示
    let overlay = document.getElementById("cart-notification-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "cart-notification-overlay";
      overlay.className = "c-cart-notification-overlay";
      overlay.addEventListener("click", this.close.bind(this));
    }
    // オーバーレイを通知と同じ親(=同じスタッキングコンテキスト)に置く。
    // body直下だと通知(ヘッダー内の文脈・z-index天井が低い)より前面になりボタンを塞ぐ。
    // 同一文脈に置けば z-index(overlay 1000 < notification 1001)で確実に背面へ回る。
    this.notification.parentElement.insertBefore(overlay, this.notification);
    overlay.classList.add("active");

    // No.75 島崎さん指摘: モーダルが開いている間も背後のページがスクロールし、
    // 通知だけが画面に貼り付いて追ってくる状態だった。暗転を出している間は
    // 背後を固定する（cart-drawer.js / details-modal.js と同じ作法）。
    document.body.classList.add("overflow-hidden");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true },
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");

    // オーバーレイを非表示
    const overlay = document.getElementById("cart-notification-overlay");
    if (overlay) overlay.classList.remove("active");

    document.body.classList.remove("overflow-hidden");

    document.body.removeEventListener("click", this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

// No.71/No.75 (2026-08-16): ページを「戻る/進む」で復元したとき (bfcache)、
// モーダルが開いたまま画面に残る・背景固定 (overflow-hidden) が解除されない
// 状態を防ぐ。開いたまま画面を離れた場合でも、復元時に必ず閉じた状態へ戻す。
window.addEventListener("pageshow", (event) => {
  if (!event.persisted) return;
  const el = document.querySelector("cart-notification");
  if (el && el.notification) {
    el.notification.classList.remove("animate", "active");
  }
  const overlay = document.getElementById("cart-notification-overlay");
  if (overlay) overlay.classList.remove("active");
  document.body.classList.remove("overflow-hidden");
});
